import React from 'react'
import moment from 'moment'
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import { browserHistory } from 'react-router'
import NavLink from '../../Routes/NavLink'
import { adminTenantAccounts } from '../../../core/controllers/Admin/AdminTenantAccounts'
import { user } from '../../../core/controllers/user';
import { modal } from '../../../core/utilities/modal';

export default class TenantTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            userAccounts: null
        };

        this.index = 0;
    }

    componentDidMount() {
        var self = this;
        adminTenantAccounts.getUsers(function(response) {
            self.setState({
                userAccounts: response.data
            })
        });
    }

    componentWillUpdate(nextProps, nextState) {
    }

    logAsUser(account) {
        adminTenantAccounts.loginAsUser(account.id, function(response) {
            modal.showInfo("Logging you into tenant.", "success", "top", "center");
            user.getUserData();
            window.location.href = '/';
        });
    }

    formatActionOptions(cell, row) {
        return <i class="pe-7s-mouse" onClick={this.logAsUser.bind(this, row)}></i>
    }

    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    formatCompany(cell, row) {
        return row.company ? row.company : 'Not Set';
    }

    formatUserType(cell, row) {
        return row.user_type;
    }

    formatLastLogin(cell, row) {
        return moment.utc(row.last_login).local().format('MMMM Do YYYY, h:mm a');
    }

    formatJoinDate(cell, row) {
        return moment.utc(row.join_date).local().format('MMMM Do YYYY, h:mm a');
    }

    flattenObject(ob) {
        var toReturn = {};
        for (var i in ob) {
            if (!ob.hasOwnProperty(i)) continue;
            if ((typeof ob[i]) == 'object') {
                var flatObject = this.flattenObject(ob[i]);
                for (var x in flatObject) {
                    if (!flatObject.hasOwnProperty(x)) continue;
                    toReturn[x] = flatObject[x];
                }
            } else {
                toReturn[i] = ob[i];
            }
        }
        return toReturn;
    }

    render(){
        var self = this;
        var userAccounts = this.state.userAccounts;

        if(userAccounts !== null) {
            userAccounts = this.state.userAccounts.map(function(account) {
                return self.flattenObject(account);
            });
        }

        return (
            <div class="content">
                {userAccounts != null ? (
                    <BootstrapTable data={userAccounts} version='4' striped search pagination>
                        <TableHeaderColumn dataField='id' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                        <TableHeaderColumn dataField='username' dataSort={ true }>Username</TableHeaderColumn>
                        <TableHeaderColumn dataField='last_login' dataFormat={this.formatLastLogin} dataSort={ true }>Last Login</TableHeaderColumn>
                        <TableHeaderColumn dataField='join_date' dataFormat={this.formatJoinDate} dataSort={ true }>Date Created</TableHeaderColumn>
                        <TableHeaderColumn dataAlign='center' width="50" dataFormat={this.formatActionOptions.bind(this)}></TableHeaderColumn>
                    </BootstrapTable>
                ) : (
                    <p>No users yet.</p>
                )}
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Admin/Tenants/TenantTable.jsx